module.exports = __webpack_public_path__ + "img/banner.a09044bf.jpeg";